module.exports = __webpack_public_path__ + "static/img/5.10476ce.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/5.png
// module id = TlVy
// module chunks = 0